import axios from "axios"


export class NewUserList {


    async getUsers() {

        return new Promise(((resolve, reject) => {

            axios.get('users/new', {
                headers: {
                    'x-jwt-token': sessionStorage.getItem("accessToken")
                }
            })
                .then((userList) => {
                    resolve(userList.data.userList);
                })
                .catch(error => {
                    reject(error)
                })
        }))

    }

}
